import React, { useReducer } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import MainContext from './contexts/MainContext';
import  { ApolloProvider } from '@apollo/client';
import reportWebVitals from './reportWebVitals';
import config from './config/apollo'
import {
  userState,
  menuState,
  configState,
  filterState,
  projectState,
  wonCompState,
  myCompState,
  adminState,
  materialState,
  competitionsState,
  wonCompetitionsState,
  notificationsState,
  projectUserState,
  userDataState,
  notificationReducer,
  wonCompetitionsReducer,
  wonCompetitionsFilterReducer,
  competitionsReducer,
  userReducer,
  configReducer,
  menuReducer,
  filterReducer,
  projectReducer,
  myCompReducer,
  adminReducer,
  materialReducer,
  projectUserReducer,
  userDataReducer,
  mapsReducer,
  mapsState
} from './reducers'
import LocalStorageFactory from './factories/LocalStorageFactory'
import './config/i18n'

const MainComponent = () => {

  const [ uState, uDispatch ] = useReducer(userReducer, userState)
  const [ cState, cDispatch ] = useReducer(configReducer, configState)
  const [ mState, mDispatch ] = useReducer(menuReducer, menuState)
  const [ fState, fDispatch ] = useReducer(filterReducer, filterState)
  const [ pState, pDispatch ] = useReducer(projectReducer, projectState)
  const [ mcState, mcDispatch ] = useReducer(myCompReducer, myCompState)
  const [ miState, miDispatch ] = useReducer(competitionsReducer, competitionsState)
  const [ wState, wDispatch ] = useReducer(wonCompetitionsReducer, wonCompetitionsState)
  const [ wfState, wfDispatch ] = useReducer(wonCompetitionsFilterReducer, wonCompState)
  const [ aState, aDispatch ] = useReducer(adminReducer, adminState)
  const [ nState, nDispatch ] = useReducer(notificationReducer, notificationsState)
  const [ matState, matDispatch ] = useReducer(materialReducer, materialState)
  const [ udState, udDispatch ] = useReducer(projectUserReducer, projectUserState)
  const [ usrState, usrDispatch ] = useReducer(userDataReducer, userDataState)
  const [ mpState, mpDispatch ] = useReducer(mapsReducer, mapsState)

  const localStorageService = LocalStorageFactory.instance()

  return (
      <ApolloProvider client={config}>
          <MainContext.Provider value={{
            user: { state: uState, dispatch: uDispatch },
            config: { state: cState, dispatch: cDispatch },
            menu: { state: mState, dispatch: mDispatch },
            filter: { state: fState, dispatch: fDispatch },
            projects: { state: pState, dispatch: pDispatch },
            my_comp_filter: { state: mcState, dispatch: mcDispatch },
            my_comp_proj: { state: miState, dispatch: miDispatch },
            won_comp: { state: wState, dispatch: wDispatch },
            won_com_filter: { state: wfState, dispatch: wfDispatch },
            admin: { state: aState, dispatch: aDispatch },
            notifications: { state: nState, dispatch: nDispatch },
            material: { state: matState, dispatch: matDispatch },
            projectUser: { state: udState, dispatch: udDispatch },
            userData: { state: usrState, dispatch: usrDispatch },
            maps: { state: mpState, dispatch: mpDispatch },
            localStorage: localStorageService
          }}>
            <React.StrictMode>
              <App />
            </React.StrictMode>
          </MainContext.Provider>
      </ApolloProvider>
  )

}

ReactDOM.render(<MainComponent />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
